import { render } from "./BlockAddress.vue?vue&type=template&id=0d806e8f"
import script from "./BlockAddress.vue?vue&type=script&lang=js"
export * from "./BlockAddress.vue?vue&type=script&lang=js"

import "./BlockAddress.vue?vue&type=style&index=0&id=0d806e8f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__